import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * Loads the pulse if we don't currently have one
 */
export const startLoadOnViewIfNeeded = store.effects.create(
  (feature: Feature) =>
    feature.actions.view.observe().pipe(
      // We only need to load if we don't currently have a pulse
      rxjsUtils.onlyWhen(
        feature.selectors.pulse.asObservable.pipe(rxjs.map(pulse => !pulse)),
      ),
      rxjs.map(action => feature.actions.load.from(action).create()),
    ),
)
